<template>
    <div class="filters">
        <ul class="list-unstyled">
            <li>
                 <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#promo" role="button" aria-expanded="true" aria-controls="promo">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Promos / Nouveautés
                 </span>
                <ul class="collapse list-unstyled show" id="promo">
                    <li>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="promotions">
                            <label class="form-check-label" for="promotions">
                                Promotions
                            </label>
                        </div>
                    </li>
                    <li>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="nouveautes">
                            <label class="form-check-label" for="nouveautes">
                                Nouveautés
                            </label>
                        </div>
                    </li>
                </ul>
                <!--<span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#categories" role="button" aria-expanded="true" aria-controls="categories">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Catégories
                 </span>-->
                <ul class="collapse list-unstyled" id="categories" v-for="(category, index) in categories">
                    <li>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox"  :value="category.id"  :id="'category'+index" v-model="selected.categories">
                            <label class="form-check-label" :for="'category' + index">
                                {{ category.name }}
                            </label>
                        </div>
                    </li>
                </ul>

                <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#packagings"
                      role="button" aria-expanded="true" aria-controls="packagings">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Conditionnement XX
                 </span>
                <ul class="collapse list-unstyled" id="packagings" v-for="(packaging, index) in packagings">
                    <li>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox"  :value="packaging.code"  :id="'packaging'+index" v-model="selected.packagings">
                            <label class="form-check-label" :for="'packaging' + index">
                                {{ packaging.label }}
                            </label>
                        </div>
                    </li>
                </ul>

            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Filters',
        props: {
            display: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                categories: [],
                packagings: [],
                selected: {
                    categories: [],
                    packagings: []
                }
            }
        },
        mounted() {
            this.loadPackaging();
        },
        watch: {
            selected: {
                handler: function () {
                    this.loadSearchProducts();
                },
                deep: true
            }
        },
        methods: {
            loadCategories: function() {
                axios.get('/api/categories', {
                })
                    .then((response) => {
                        this.categories = response.data.data;
                        this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            loadPackaging: function() {
                axios.get('/api/packaging', {
                })
                    .then((response) => {
                        this.packagings = response.data.data;
                        this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            loadSearchProducts: function() {
                axios.get('/api/search-produtcs', {
                    params: this.selected
                })
                    .then((response) => {
                        this.products = response.data.data;
                        this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    }
</script>
